import { http } from 'yxt-biz-pc/packages/api';

export const setWatermarkConfig = () => {
  const url = '/backend/liveroom/watermarkconfig';
  return http.tlive.get(url);
};

export const fetchLogo = () => {
  const url = 'logo';
  return http.tlive.get(url);
};

export const createTLiveRoom = (params) => {
  const url = '/backend/liveroom';
  return http.tlive.post(url, params);
};

export const getTLiveRoomInfo = (roomId) => {
  const url = `/backend/liveroom/${roomId}`;
  return http.tlive.get(url);
};
export const updateTliveRoom = (roomId, params) => {
  const url = `/backend/liveroom/${roomId}`;
  return http.tlive.put(url, params);
};

